(function () {
  function initDrawer(root) {
    if (!root || root.dataset.cpNavInit === '1') return;
    root.dataset.cpNavInit = '1';

    var panels = root.querySelectorAll('[data-cp-panel]');
    var rootPanel = root.querySelector('[data-cp-panel="root"]');

    function showPanel(id) {
      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-cp-panel') === id;
        panel.classList.toggle('cp-nav__panel--active', isTarget);
        if (isTarget) {
          panel.removeAttribute('hidden');
        } else if (panel.getAttribute('data-cp-panel') !== 'root') {
          panel.setAttribute('hidden', '');
        }
      });
      if (rootPanel && id !== 'root') {
        rootPanel.classList.remove('cp-nav__panel--active');
        rootPanel.setAttribute('hidden', '');
      } else if (rootPanel) {
        rootPanel.classList.add('cp-nav__panel--active');
        rootPanel.removeAttribute('hidden');
      }
    }

    function resetPanels() {
      showPanel('root');
      root.querySelectorAll('.cp-nav__accordion[open]').forEach(function (el) {
        el.removeAttribute('open');
      });
    }

    root.querySelectorAll('[data-cp-goto]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var id = btn.getAttribute('data-cp-goto');
        if (id) showPanel(id);
      });
    });

    root.querySelectorAll('[data-cp-back]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        showPanel('root');
      });
    });

    var searchBtn = root.querySelector('[data-cp-nav-search]');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        if (typeof window.__closeCsMobileMenu === 'function') {
          window.__closeCsMobileMenu();
        }
        window.setTimeout(function () {
          var input = document.getElementById('cs-input');
          if (input) {
            input.focus();
            input.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          }
        }, 350);
      });
    }

    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      var observer = new MutationObserver(function () {
        if (!drawerDetails.hasAttribute('open')) resetPanels();
      });
      observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    }

    resetPanels();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cp-nav-drawer]').forEach(initDrawer);
  });
})();
